import { createApi } from '@reduxjs/toolkit/query/react';
import { List } from 'immutable';
import DeepDiveLink from 'models/Tools/DeepDiveLink';
import { axiosBaseQuery } from 'services/api';

// Tag for cache invalidation
export const DEEP_DIVE_LINK_TAG = 'DeepDiveLink';

export const deepDiveLinkApi = createApi({
  reducerPath: 'deepDiveLinkApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/material-links/',
  }),
  tagTypes: [DEEP_DIVE_LINK_TAG],
  endpoints: builder => ({
    // Get list of deep dive links
    getDeepDiveLinks: builder.query({
      query: params => ({
        method: 'GET',
        params,
      }),
      transformResponse: data => List(data.map(item => new DeepDiveLink(item))),
      providesTags: [DEEP_DIVE_LINK_TAG],
    }),

    // Create deep dive link
    createDeepDiveLink: builder.mutation({
      query: data => ({
        method: 'POST',
        data,
      }),
      invalidatesTags: [DEEP_DIVE_LINK_TAG],
    }),

    // Update deep dive link (handles file upload via FormData if needed)
    updateDeepDiveLink: builder.mutation({
      query: link => {
        const uploadingFile = Object.entries(link).find(
          ([key, value]) => key.startsWith('file') && value
        );
        let formData;
        let headers;

        if (uploadingFile) {
          formData = new FormData();
          Object.entries(link).forEach(([key, value]) => {
            formData.append(key, value);
          });
          headers = { 'content-type': 'multipart/form-data' };
        }

        return {
          url: `${link.id}/`,
          method: 'PATCH',
          data: formData || link,
          headers,
        };
      },
      invalidatesTags: [DEEP_DIVE_LINK_TAG],
    }),

    // Delete deep dive link
    deleteDeepDiveLink: builder.mutation({
      query: id => ({
        url: `${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [DEEP_DIVE_LINK_TAG],
    }),
  }),
});

export const {
  useGetDeepDiveLinksQuery,
  useCreateDeepDiveLinkMutation,
  useUpdateDeepDiveLinkMutation,
  useDeleteDeepDiveLinkMutation,
} = deepDiveLinkApi;
